import { render, staticRenderFns } from "./ShujiHokoku.vue?vue&type=template&id=65064af6&scoped=true"
import script from "./ShujiHokoku.vue?vue&type=script&lang=js"
export * from "./ShujiHokoku.vue?vue&type=script&lang=js"
import style0 from "./ShujiHokoku.vue?vue&type=style&index=0&id=65064af6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65064af6",
  null
  
)

export default component.exports